// Price multiplier per tier vs "base" restaurant cost (tier 3 = baseline 1.00)
export const PRICE_MULTIPLIERS = {
  1: 0.80, // Aldi/Lidl — muy económico
  2: 0.91, // Mercadona/Dia — económico
  3: 1.00, // Alcampo/Carrefour — precio medio (base)
  4: 1.13, // Hipercor/Spar — precio alto
  5: 1.30, // El Corte Inglés — premium
};
